export default "__VITE_ASSET__B2preb_k__"